import script from "./AsesoriaRegistralView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaRegistralView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaRegistralView.vue?vue&type=style&index=0&id=7154fec0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7154fec0"]])

export default __exports__